import type { FaireProductEntity } from "../../entity_types/product";

export const p_nx4uhwwveg: FaireProductEntity = {
  token: "p_nx4uhwwveg",
  type: "product",
  name: "[12pk] She's The Sauce Buffalo Sauce",
  brandToken: "b_dv6f48qrzb",
  brandName: "She's The Sauce",
  imageUrl:
    "https://cdn.faire.com/fastly/fa30aa89d1b44e28a3e64fad0ac230d99a717cccebb1377e14b27a8579bb828d.webp",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f8a185d0a7a039cbbed9fcfd8e801c7d7ab47deab09eaa5800bd7332cd7bde65.webp",
    "https://cdn.faire.com/fastly/211206711799e37b759fedf1eff0031f081fbbaf4a862366512356e5987fc5dc.png",
    "https://cdn.faire.com/fastly/69901f22bd709dd93b6e972168075d36752b21c7352505ad67e71d8a6653841d.png",
  ],
  priceDollars: 8.5,
  description:
    "Hot & Rich\n\nMeet Buffalo Babe whose fiery, creamy, and impossible to ignore. She brings bold buffalo heat with a smooth, buttery finish that keeps you coming back for more. She’s spicy. She’s confident. She’s the one stealing attention at the table. And she’ll light up anything she touches.\n\n4 Grams of Protein per serving\n\n2 Grams of Fiber per serving\n\n0 Grams of Sugar per serving\n\nYOUR GO-TO SAUCE FOR:\n\nCoating crispy wings, dipping fries, drizzling over grilled chicken, mixing into wraps, or adding chaos to eggs, bowls, and basically anything that needs a personality.\n\nGum Free\nLow sugar\nRefined sugar free\nGluten free\nSeed oil free.",
  tags: [],
  msrpDollars: 12.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-09T05:17:11.816Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
